import {
    Button,
    Checkbox,
    DatePicker,
    Drawer,
    Form,
    Input,
    notification,
    Radio,
    Row,
    Select,
    Space,
} from "antd";
import { AntInput } from "../../../shared/widges/antinput";
import { useEffect, useState } from "react";
import styles from "./scedulereports.module.scss";
import moment from "moment-timezone";
import { RRule, datetime } from "rrule";
import { ReportServices } from "../../../base/service/apiServices";
import { AntTextAreas } from "../../../shared/widges/anttextArea";
import React from "react";
import { DateTime } from 'luxon';
import { hassAccess } from "../../../base/utils";
import { UserSettingsActions } from "../../../store/slices/settings_slice/user_settings_slice";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";


const CreateScheduledReports = ({ drawerOpen, drawerOpenClose }: any) => {
    const timezones = moment.tz.names();
    const [form] = Form.useForm();
    const { RangePicker } = DatePicker;
    const CheckboxGroup = Checkbox.Group;
    const [open, setOpen] = useState<any>(false);
    const [endDateVisible, setEndDateVisible] = useState<any>(false);
    const { Option } = Select;
    const [hoursVal, setHoursVal] = useState<any>();
    const [minutesVal, setMinutesVal] = useState<any>();
    const monthDates = Array.from({ length: 31 }, (_, i) => i + 1);
    const repeatEveryDays = Array.from({ length: 15 }, (_, i) => i + 1);
    const repeatEveryWeekly = [1, 2, 3, 4];
    const repeatEveryMonth = Array.from({ length: 7 }, (_, i) => i + 1);
    const hours = Array.from({ length: 24 }, (_, i) =>
        String(i).padStart(2, "0")
    );
    const minutes = Array.from({ length: 60 }, (_, i) =>
        String(i).padStart(2, "0")
    );
    const [loading, setLoading] = useState<any>(true);
    const dispatch = useDispatcher()
    const fileType = [
        { label: "PDF", value: "PDF" },
        { label: "CSV", value: "CSV" },
        { label: "XLS", value: "XLS" },
        { label: "XLSL", value: "XLSL" },
    ];
    const daysOfWeek = [
        { label: "Sun", value: "SU" },
        { label: "Mon", value: "MO" },
        { label: "Tue", value: "TU" },
        { label: "Wed", value: "WE" },
        { label: "Thu", value: "TH" },
        { label: "Fri", value: "FR" },
        { label: "Sat", value: "SA" },
    ];
    const [reportData, setReportData] = useState<any>({
        reportName: "",
        recurrence: "",
        rrule: "",
        isRecurr: 1,
        timezone: "Asia/Kolkata",
        isSetPassword: 0,
        setPassword: "",
        fileType: [],
        toAddr: "",
        subject: "",
        message: "",
    });
    const [rruleFormat, setRruleFormat] = useState<any>({
        startDate: "",
        endDate: "",
        daysOfWeek: [],
        weekNo: "",
        daysOfMonth: "",
        startDataRange: "",
    });
    const [repeatVal, setRepeatVal] = useState<any>();
    const [tableData, setTableData] = useState<any>();
    const [dataSource, setDataSource] = useState<any>();
    const [delModal, setDelModal] = useState<any>({
        isVisible: false,
        id: ""
    });
    const reportNames = [
        "Answered Call Profile Report(Voice)",
        "Missed Call Report(Voice)",
        "Outbound Call Summary Report(Voice)",
        "Interaction Report(Voice)",
        "Transfer Call Report(Voice)",
        "Call Back Summary Report(Voice)",
        "Chats report(Web Chat)",
        "Agent Chat Report(Web Chat)",
        "Agent ACW chat report(Web Chat)",
        "Email Report",
        "Agent Email Reports(Email)",
        "Interaction report(Email)",
        "Sms report",
        "Agent sms report(SMS)",
        "Interaction Report(SMS)",
        "Whatsapp report",
        "Agent Whatsapp report(Whatsapp)",
        "ACW Chat Report(Whatsapp)",
        "Facebook report",
        "Agent Chat report(Facebook)",
        "ACW Chat Report(Facebook)",
        "Instagram report",
        "Agent Chat report(Instagram)",
        "ACW Chat Report(Instagram)",
        "Agent Call Summary Report",
        "Agent Performance Report",
        "Query Handling Time",
        "Login and Logout Report",
        "Agent Status Report",
        "Feedback Report",
        "AI Call Quality Report",
        "AI Chat Quality Report",
        "Performance Comparison Report between Bot and Agent",
        "Bot Performance Report",
    ]

    // useEffect(() => {
    //     getScheduledReport();
    // }, [])
    const onClose = () => {
        setOpen(false);
    };
    //   const showDrawer = () => {
    //     setOpen(!open);
    //     setReportData({
    //       reportName: "",
    //       recurrence: "",
    //       rrule: "",
    //       isRecurr: 1,
    //       timezone: "Asia/Kolkata",
    //       isSetPassword: 0,
    //       setPassword: "",
    //       fileType: [],
    //       toAddr: "",
    //       subject: "",
    //       message: "",
    //     })
    //     form.resetFields();
    //   };

    const luxonDateTimeFun = (): any => {
        const startDateFormat = rruleFormat.startDate;
        return (DateTime.fromObject({
            year: startDateFormat[0],
            month: startDateFormat[1],
            day: startDateFormat[2],
            hour: hoursVal,
            minute: minutesVal,
        }, { zone: reportData.timezone })).toJSDate();
    }

    const dailyRecurrence = () => {
        let rule,
            startDateFormat = rruleFormat.startDate,
            endDateFormat = rruleFormat.endDate;
        // endDateVisible
        //     ? 
            (rule = new RRule({
                freq: RRule.DAILY,
                // dtstart: datetime(
                //   startDateFormat[0],
                //   startDateFormat[1],
                //   startDateFormat[2],
                //   hoursVal,
                //   minutesVal
                // ),
                dtstart: luxonDateTimeFun(),
                until: datetime(endDateFormat[0], endDateFormat[1], endDateFormat[2]),
                interval: repeatVal,
                // tzid: reportData.timezone,
            }))
            // : (rule = new RRule({
            //     freq: RRule.DAILY,
            //     // dtstart: datetime(
            //     //   startDateFormat[0],
            //     //   startDateFormat[1],
            //     //   startDateFormat[2],
            //     //   hoursVal,
            //     //   minutesVal
            //     // ),
            //     dtstart: luxonDateTimeFun(),
            //     interval: repeatVal,
            //     // tzid: reportData.timezone,
            // }));
        setReportData({
            ...reportData,
            rrule: rule.toString(),
        });
        return rule;
    };
    const weeklyRecurrence = () => {
        let rule,
            startDateFormat = rruleFormat.startDate,
            endDateFormat = rruleFormat.endDate;
        const rruleMapping: any = {
            MO: RRule.MO,
            TU: RRule.TU,
            WE: RRule.WE,
            TH: RRule.TH,
            FR: RRule.FR,
            SA: RRule.SA,
            SU: RRule.SU,
        };

        const rruleArray = rruleFormat.daysOfWeek.map(
            (elem: any) => rruleMapping[elem]
        );

        // endDateVisible
        //     ? 
            (rule = new RRule({
                freq: RRule.WEEKLY,
                // dtstart: datetime(
                //   startDateFormat[0],
                //   startDateFormat[1],
                //   startDateFormat[2],
                //   hoursVal,
                //   minutesVal
                // ),
                dtstart: luxonDateTimeFun(),
                until: datetime(endDateFormat[0], endDateFormat[1], endDateFormat[2]),
                interval: repeatVal,
                byweekday: rruleArray,
                // tzid: reportData.timezone,
            }))
            // : (rule = new RRule({
            //     freq: RRule.WEEKLY,
            //     // dtstart: datetime(
            //     //   startDateFormat[0],
            //     //   startDateFormat[1],
            //     //   startDateFormat[2],
            //     //   hoursVal,
            //     //   minutesVal
            //     // ),
            //     dtstart: luxonDateTimeFun(),
            //     interval: repeatVal,
            //     byweekday: rruleArray,
            //     // tzid: reportData.timezone,
            // }));
        setReportData({
            ...reportData,
            rrule: rule.toString(),
        });
        return rule;
    };
    const monthlyRecurrence = () => {
        let rule,
            startDateFormat = rruleFormat.startDate,
            endDateFormat = rruleFormat.endDate;
        let i: any,
            tempArr: any = [];
        i = rruleFormat.weekNo;
        if (i === 0) {
            if (rruleFormat.daysOfMonth === "SU") tempArr.push(RRule.SU);
            else if (rruleFormat.daysOfMonth === "MO") tempArr.push(RRule.MO);
            else if (rruleFormat.daysOfMonth === "TU") tempArr.push(RRule.TU);
            else if (rruleFormat.daysOfMonth === "WE") tempArr.push(RRule.WE);
            else if (rruleFormat.daysOfMonth === "TH") tempArr.push(RRule.TH);
            else if (rruleFormat.daysOfMonth === "FR") tempArr.push(RRule.FR);
            else if (rruleFormat.daysOfMonth === "SA") tempArr.push(RRule.SA);
        } else {
            if (rruleFormat.daysOfMonth === "SU") tempArr.push(RRule.SU.nth(i));
            else if (rruleFormat.daysOfMonth === "MO") tempArr.push(RRule.MO.nth(i));
            else if (rruleFormat.daysOfMonth === "TU") tempArr.push(RRule.TU.nth(i));
            else if (rruleFormat.daysOfMonth === "WE") tempArr.push(RRule.WE.nth(i));
            else if (rruleFormat.daysOfMonth === "TH") tempArr.push(RRule.TH.nth(i));
            else if (rruleFormat.daysOfMonth === "FR") tempArr.push(RRule.FR.nth(i));
            else if (rruleFormat.daysOfMonth === "SA") tempArr.push(RRule.SA.nth(i));
        }

        // endDateVisible
        //     ? 
            (rule = new RRule({
                freq: RRule.MONTHLY,
                // dtstart: datetime(
                //   startDateFormat[0],
                //   startDateFormat[1],
                //   startDateFormat[2],
                //   hoursVal,
                //   minutesVal
                // ),
                dtstart: luxonDateTimeFun(),
                until: datetime(endDateFormat[0], endDateFormat[1], endDateFormat[2]),
                interval: repeatVal,
                byweekday: tempArr,
                // tzid: reportData.timezone,
            }))
            // : (rule = new RRule({
            //     freq: RRule.MONTHLY,
            //     // dtstart: datetime(
            //     //   startDateFormat[0],
            //     //   startDateFormat[1],
            //     //   startDateFormat[2],
            //     //   hoursVal,
            //     //   minutesVal
            //     // ),
            //     dtstart: luxonDateTimeFun(),
            //     interval: repeatVal,
            //     byweekday: tempArr,
            //     // tzid: reportData.timezone,
            // }));
        setReportData({
            ...reportData,
            rrule: rule.toString(),
        });
        return rule;
    };
    const onSubmit = () => {
        form
            .validateFields()
            .then((_: any) => {
                try {
                    setLoading(true);
                    let rule: any;
                    if (reportData.recurrence === "Once") {
                        rule = new RRule({
                            freq: RRule.DAILY,
                            // dtstart: datetime(
                            //   startDateFormat[0],
                            //   startDateFormat[1],
                            //   startDateFormat[2],
                            //   hoursVal,
                            //   minutesVal
                            // ),
                            dtstart: luxonDateTimeFun(),
                            // tzid: reportData.timezone,
                            count: 1,
                        });
                        setReportData({
                            ...reportData,
                            rrule: rule.toString(),
                        });
                    } else if (reportData.recurrence === "Daily") {
                        rule = dailyRecurrence();
                    } else if (reportData.recurrence === "Weekly") {
                        rule = weeklyRecurrence();
                    } else if (reportData.recurrence === "Monthly") {
                        rule = monthlyRecurrence();
                    }
                    const nextOccurrence = rule.after(new Date());
                    const body = {
                        reportId: reportData?.reportId,
                        reportName: reportData.reportName,
                        recurrence: reportData.recurrence,
                        isRecurr: 1,
                        rrule: rule?.toString(),
                        timezone: reportData.timezone ?? null,
                        isSetPassword: reportData.isSetPassword,
                        setPassword: reportData.setPassword,
                        fileType: JSON.stringify(reportData.fileType),
                        toAddr: reportData.toAddr,
                        subject: reportData.subject,
                        message: reportData.message,
                        nextOccurrence: nextOccurrence?.getTime(),
                        startDataRange: rruleFormat?.startDataRange,
                        endDataRange: rruleFormat?.endDataRange
                    };
                    insertScheduledReport(body);
                    setOpen(false);
                } catch (error) {
                    setLoading(false);
                }
            })
            .catch((e) => {
                notification.error({
                    message: "Please enter mandatory fields",
                    placement: "topRight",
                    className: "toastNotification error",
                    icon: <span className="icon__Error24" />,
                    closeIcon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                        >
                            <path
                                d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z"
                                fill="#757676"
                            />
                        </svg>
                    ),
                    duration: 3,
                    top: 70,
                });
            });
    };

    const insertScheduledReport = (body: any) => {
        ReportServices.post(body, "/insert_schedule_report_info")
            .then((response: any) => {
                if (response.data.statusCode === 200) {
                     drawerOpenClose();
                    // getScheduledReport();
                    notification.success({
                        message: 'Schedule inserted successfully',
                        className: "toastNotification success",
                        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
                        </svg>,
                        closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
                        </svg>,
                        placement: 'topRight',
                        duration: 5,
                        top: 70
                    });
                }
            })
            .catch((error) => {
                console.log(error)
            }).finally(() => {
                setLoading(false);
            });
    }

    // const getScheduledReport = () => {
    //     ReportServices.get("/get_schedule_report_info")
    //         .then((response: any) => {
    //             if (response.data.statusCode === 200) {
    //                 setTableData(response.data.result);
    //                 setDataSource(response.data.result);
    //             } else if (response.data.statusCode === 404) {
    //                 setTableData([]);
    //                 setDataSource([]);
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         }).finally(() => {
    //             setLoading(false);
    //         });
    // }
    const disabledDate = (current: any) => {
        return current && current < moment().startOf('day');
    };
    const disabledFutureDate = (current: any) => {
        return current && current > moment().startOf('day');
    };
     const restrictedReports = [
            "Email Report",
            "Agent Email Reports",
            "Sms report",
            "Agent sms report",
            "Whatsapp report",
            "Agent Whatsapp report",
            "Facebook report",
            "Instagram report",
        ];

    return (
        <div>
            <Drawer
                className={`reportschedulerightbar`}
                title="Schedule Reports"
                width={720}
                onClose={drawerOpenClose}
                open={drawerOpen}
                footer={
                    <>
                        <div className={styles.footerbtns}>
                            <button className="buttonCancel" onClick={drawerOpenClose}>
                                Cancel
                            </button>
                            <button className="buttonGreenCreate" onClick={onSubmit}>
                                {" "}
                                Schedule
                            </button>
                        </div>
                    </>
                }
            // bodyStyle={{ paddingBottom: 80 }}
            >
                <Form name="basic" form={form}>
                    <div className={`${styles.grd} schedulegrdblock`}>
                        <div className="formblock">
                            <Form.Item
                                label="Schedule Report Name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Required data missing",
                                    },
                                ]}
                                validateTrigger={['onBlur']}
                            >
                                <Select
                                    className="antSelect"
                                    showSearch
                                    getPopupContainer={(trigger) => trigger.parentNode}
                                    filterOption={(input: any, option: any) =>
                                        option?.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    suffixIcon={<span className="icon__SelectDownArrow16"></span>}
                                    placeholder="Report Name"
                                    // options={countryTimezones}
                                    onChange={(e: any, f: any) => {
                                        if (!hassAccess('scheduleReport') && restrictedReports?.includes(f.children)) {
                                            dispatch(UserSettingsActions.setUpgradePlan(true))
                                            return;
                                        }
                                        setReportData({
                                            ...reportData,
                                            reportId: e,
                                            reportName: f.children,
                                        })
                                    }}
                                    value={reportData.reportId || null}
                                >
                                    {reportNames?.map((item: any, index: any) => (
                                        <Option key={index + 1} value={index + 1}>
                                            {item}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                    {/* </Form> */}
                    <div className={styles.outerline}>
                        <div className={`${styles.grd} schedulegrdblock`}>
                            <div className="formblock">
                                <Form.Item
                                    label="Recurrence"
                                    name="recurrence"
                                    rules={[{ required: true, message: 'Required data missing' }]}
                                >
                                    <Radio.Group
                                        className="recurrenceradio"
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                recurrence: e.target.value,
                                                rrule: "",
                                            });
                                        }}
                                        value={reportData.recurrence}
                                    >
                                        <Radio value={"Once"}>
                                            <p>Once</p>
                                        </Radio>
                                        <Radio value={"Daily"}>
                                            <p>Daily</p>
                                        </Radio>
                                        <Radio value={"Weekly"}>
                                            <p>Weekly</p>
                                        </Radio>
                                        <Radio value={"Monthly"}>
                                            <p>Monthly</p>
                                        </Radio>
                                    </Radio.Group></Form.Item>
                            </div>
                        </div>
                        {
                            reportData?.recurrence != "" &&
                            <>
                                {reportData.recurrence !== "Once" && (
                                    <div>
                                        <div className={`${styles.grd} schedulegrdblock`}>

                                            <Form.Item label="Repeat Every" name="repeat" >
                                                <div className={styles.everydays}>
                                                    <Select
                                                        className="antSelect selectevery"
                                                        //popupClassName="antSelectPopover"
                                                        getPopupContainer={(trigger) => trigger.parentNode}
                                                        suffixIcon={
                                                            <span className="icon__SelectDownArrow16"></span>
                                                        }
                                                        defaultValue=""
                                                        value={repeatVal}
                                                        onChange={(e: any) => setRepeatVal(e)}
                                                    >
                                                        {reportData.recurrence === "Daily"
                                                            ? repeatEveryDays.map((days: any) => (
                                                                <Option key={days} value={days}>
                                                                    {days}
                                                                </Option>
                                                            ))
                                                            : reportData.recurrence === "Weekly"
                                                                ? repeatEveryWeekly.map((days: any) => (
                                                                    <Option key={days} value={days}>
                                                                        {days}
                                                                    </Option>
                                                                ))
                                                                : reportData.recurrence === "Monthly"
                                                                    ? repeatEveryMonth.map((days: any) => (
                                                                        <Option key={days} value={days}>
                                                                            {days}
                                                                        </Option>
                                                                    ))
                                                                    : ""}
                                                    </Select>
                                                    <span>
                                                        {reportData.recurrence === "Daily"
                                                            ? "Days"
                                                            : reportData.recurrence === "Weekly"
                                                                ? "Weekly"
                                                                : "Month"}
                                                    </span>
                                                </div>
                                            </Form.Item>
                                        </div>
                                    </div>
                                )}
                                {reportData.recurrence === "Weekly" && (
                                    <div className={styles.checkboxgrp}>
                                        <CheckboxGroup
                                            options={daysOfWeek}
                                            onChange={(e: any) => {
                                                setRruleFormat({
                                                    ...rruleFormat,
                                                    daysOfWeek: e,
                                                });
                                            }}
                                        />
                                    </div>
                                )}
                                {reportData.recurrence === "Monthly" && (
                                    <>
                                        {" "}
                                        <div className={styles.onselectflexcontainer}>
                                            <div>
                                                <Select
                                                    className="antSelect selectevery autowidthselect"
                                                    //popupClassName="antSelectPopover"
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    suffixIcon={
                                                        <span className="icon__SelectDownArrow16"></span>
                                                    }
                                                    placeholder="Select Business Hours"
                                                    defaultValue="On"
                                                    onChange={(e: any) => {
                                                        setRruleFormat({
                                                            ...rruleFormat,
                                                            weekNo: e,
                                                        });
                                                    }}
                                                >
                                                    <Option key={1} value={0}>
                                                        On
                                                    </Option>
                                                    <Option key={2} value={1}>
                                                        First
                                                    </Option>
                                                    <Option key={3} value={2}>
                                                        Second
                                                    </Option>
                                                    <Option key={4} value={3}>
                                                        Third
                                                    </Option>
                                                    <Option key={5} value={4}>
                                                        Fourth
                                                    </Option>
                                                    <Option key={6} value={-1}>
                                                        Last
                                                    </Option>
                                                </Select>
                                            </div>

                                            <div>
                                                <Select
                                                    className="antSelect  selectevery autowidthselect"
                                                    //popupClassName="antSelectPopover"
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    suffixIcon={
                                                        <span className="icon__SelectDownArrow16"></span>
                                                    }
                                                    placeholder="Select Business Hours"
                                                    value={rruleFormat.daysOfMonth}
                                                    onChange={(e: any) =>
                                                        setRruleFormat({
                                                            ...rruleFormat,
                                                            daysOfMonth: e,
                                                        })
                                                    }
                                                >
                                                    {
                                                        rruleFormat?.weekNo !== 0 ?
                                                            (<>
                                                                <Option key={1} value={"SU"}>
                                                                    Sun
                                                                </Option>
                                                                <Option key={2} value={"MO"}>
                                                                    Mon
                                                                </Option>
                                                                <Option key={3} value={"TU"}>
                                                                    Tue
                                                                </Option>
                                                                <Option key={4} value={"WE"}>
                                                                    Wed
                                                                </Option>
                                                                <Option key={5} value={"TH"}>
                                                                    Thu
                                                                </Option>
                                                                <Option key={6} value={"FR"}>
                                                                    Fri
                                                                </Option>
                                                                <Option key={7} value={"SA"}>
                                                                    Sat
                                                                </Option>
                                                            </>)
                                                            : (monthDates.map((elem: any, index: number) =>
                                                                <Option key={index} value={elem}>
                                                                    {elem}
                                                                </Option>
                                                            ))
                                                    }
                                                </Select>
                                                <span className={styles.selectdayspan}> Day</span>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div>
                                    {reportData.recurrence === "Once" &&
                                        <div className={`${styles.grd} ${styles.dateranges} schedulegrdblock`}>
                                            <div className={styles.labelstraight}>
                                                <Form.Item
                                                    className="hiddentext"
                                                    label="Select Data Range"
                                                    name="dataRange"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Required data missing",
                                                        },
                                                    ]}
                                                >
                                                    <RangePicker
                                                        onChange={(dates: any) => {
                                                            if (dates && dates.length === 2) {
                                                                const start = dates[0];
                                                                const end = dates[1];

                                                                setRruleFormat({
                                                                    ...rruleFormat,
                                                                    startDataRange: moment(start).startOf('day').valueOf(),
                                                                    endDataRange: moment(end).endOf('day').valueOf(),
                                                                });
                                                            } else {
                                                                setRruleFormat({
                                                                    ...rruleFormat,
                                                                    startDataRange: "",
                                                                    endDataRange: "",
                                                                });
                                                            }
                                                        }}
                                                        disabledDate={disabledFutureDate}
                                                        getPopupContainer={(trigger: any) => trigger.parentNode as HTMLElement}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                    {/* <Form layout="horizontal"> */}
                                    <div className={`${styles.grd} ${styles.dateranges} schedulegrdblock`}>
                                        <div className={styles.labelstraight}>
                                            <Form.Item
                                                className="hiddentext"
                                                label="Start Date"
                                                name="startDate"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Required data missing",
                                                    },
                                                ]}
                                            >
                                                <DatePicker
                                                    className="antpickermanual"
                                                    onChange={(e: any) => {
                                                        if (e) {
                                                            setRruleFormat({
                                                                ...rruleFormat,
                                                                startDate: moment(
                                                                    e._d,
                                                                    "ddd MMM DD YYYY HH:mm:ss"
                                                                )
                                                                    .format("YYYY-MM-DD")
                                                                    .split("-"),
                                                            });
                                                        } else {
                                                            setRruleFormat({
                                                                ...rruleFormat,
                                                                startDate: "",
                                                            });
                                                        }
                                                    }}
                                                    getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                        </div>
                                        <div className={`${styles.labelstraight} modalblocks`}>
                                            {reportData.recurrence !== "Once" && (
                                                <Form.Item
                                                    className="hiddentext"
                                                    label="End Date"
                                                    name="endDate"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Required data missing",
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        className="antpickermanual"
                                                        // disabled={!endDateVisible}
                                                        onChange={(e: any) => {
                                                            if (e) {
                                                                setRruleFormat({
                                                                    ...rruleFormat,
                                                                    endDate: moment(
                                                                        e._d,
                                                                        "ddd MMM DD YYYY HH:mm:ss"
                                                                    )
                                                                        .format("YYYY-MM-DD")
                                                                        .split("-"),
                                                                });
                                                            } else {
                                                                setRruleFormat({
                                                                    ...rruleFormat,
                                                                    endDate: "",
                                                                });
                                                            }
                                                        }}
                                                        disabledDate={disabledDate}
                                                        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
                                                    />
                                                </Form.Item>
                                            )}
                                        </div>
                                    </div>
                                    {/* {reportData.recurrence !== "Once" && (
                                        <div className={styles.labelstraight}>
                                            <Checkbox
                                                className="hiddentext"
                                                onChange={(e: any) =>
                                                    setEndDateVisible(e.target.checked)
                                                }
                                            >
                                                Set Expiry Date
                                            </Checkbox>
                                        </div>
                                    )} */}
                                    {/* </Form> */}
                                </div>
                                <div className={`${styles.grd} ${styles.dateranges} schedulegrdblock`}>
                                    <div className={`${styles.labelstraight} ${styles.labelstraightresp}`}>
                                        <div>
                                            <label>{reportData.recurrence !== "Once" ? 'Frequency occurs once at' : 'Time'}<span className={styles.red}>*</span></label>
                                        </div>
                                        <div className={`modalblocks ${styles.resptime}`}>
                                            <Form.Item className="hiddentext"
                                                label={reportData.recurrence !== "Once" ? 'Frequency occurs once at' : 'Time'}
                                                name={reportData.recurrence !== "Once" ? 'Frequency occurs once at' : 'Time'}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Required data missing",
                                                    },
                                                ]}>
                                                <Select
                                                    className="antSelect selectevery"
                                                    //popupClassName="antSelectPopover"
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    suffixIcon={
                                                        <span className="icon__SelectDownArrow16"></span>
                                                    }
                                                    placeholder="Select Business Hours"
                                                    defaultValue=""
                                                    value={hoursVal}
                                                    onChange={(e: any) => setHoursVal(e)}
                                                >
                                                    {hours.map((hour) => (
                                                        <Option key={hour} value={hour}>
                                                            {hour}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        <span>Hour{hoursVal > 1 ? "s" : ""}</span>
                                        </div>

                                        <div className={`modalblocks ${styles.resptime}`}>
                                            <Form.Item className="marbtmnon"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Required data missing",
                                                    },
                                                ]}>
                                                <Select
                                                    className="antSelect selectevery"
                                                    //popupClassName="antSelectPopover"
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    suffixIcon={
                                                        <span className="icon__SelectDownArrow16"></span>
                                                    }
                                                    placeholder="Select Business Hours"
                                                    defaultValue=""
                                                    value={minutesVal}
                                                    onChange={(e: any) => setMinutesVal(e)}
                                                >
                                                    {minutes.map((minute) => (
                                                        <Option key={minute} value={minute}>
                                                            {minute}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        <span>Minute{minutesVal > 1 ? "s" : ""}</span>
                                        </div>
                                        {/* </> */}
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                    <div className={styles.outerline}>
                        <div>
                            {/* <Form layout="horizontal"> */}
                            <div
                                className={`${styles.labeldown} ${styles.labeldownnewtimezone}`}
                            >
                                <label>Time Zone:</label>
                                <Select
                                    className="antSelect"
                                    getPopupContainer={(trigger) => trigger.parentNode}
                                    suffixIcon={
                                        <span className="icon__SelectDownArrow16"></span>
                                    }
                                    placeholder="Select Timezone"
                                    showSearch
                                    filterOption={(input: any, option: any) =>
                                        option?.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={(e: any) => {
                                        setReportData({
                                            ...reportData,
                                            timezone: e,
                                        });
                                    }}
                                    value={reportData.timezone}
                                >
                                    {timezones.map((timezone) => (
                                        <Option key={timezone} value={timezone}>
                                            {timezone}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                        {/* <div className={styles.labelstraight}>
                            <div>
                                <Checkbox
                                    onChange={(e: any) => {
                                        setReportData({
                                            ...reportData,
                                            isSetPassword: e.target.checked ? 1 : 0,
                                        });
                                    }}
                                    checked={reportData.isSetPassword}
                                >
                                    {" "}
                                    Set Password
                                </Checkbox>
                            </div>
                            {reportData.isSetPassword === 1 && (
                                <div>
                                    <Space
                                        direction="vertical"
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                setPassword: e.target.value,
                                            });
                                        }}
                                    >
                                        <Input.Password placeholder="Enter Password" />
                                    </Space>
                                </div>
                            )}
                        </div> */}
                        <div className={`${styles.grd} schedulegrdblock`}>
                            <div className="formblock">
                                <Form.Item
                                    label="File Type"
                                    name="fileType"
                                    rules={[{
                                        required: true,
                                        message: 'Required data missing'
                                    },
                                    ]}
                                    validateTrigger={['onBlur', 'onChange']}
                                >
                                    <CheckboxGroup
                                        options={fileType}
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                fileType: e,
                                            });
                                        }}
                                        value={reportData.fileType}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className={`mailMessage ${styles.outerline}`}>
                        <div className={`${styles.grd} modalblocks schedulegrdblock`}>
                            <div className={`${styles.labeldown} formblock`}>
                                <Form.Item
                                    label="To"
                                    name="to"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Required data missing",
                                        },
                                        {
                                            type: "email",
                                            message: "Please enter a valid email address",
                                          },
                                    ]}
                                    validateTrigger={['onBlur', 'onChange']}
                                >

                                    <AntInput
                                        placeHolder="Enter Email ID"
                                        className="textBox"
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                toAddr: e.target.value,
                                            });
                                        }}
                                        value={reportData.toAddr}
                                    />
                                </Form.Item>
                            </div>
                            <div className={`${styles.labeldown} formblock`}>
                                <Form.Item
                                    label="Subject"
                                    name="subject"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Required data missing",
                                        },
                                    ]}
                                    validateTrigger={['onBlur', 'onChange']}
                                >
                                    <AntInput
                                        placeHolder="Enter Subject"
                                        className="textBox"
                                        maxLength={150}
                                        showCount={true}
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                subject: e.target.value,
                                            });
                                        }}
                                        value={reportData.subject}
                                    />
                                </Form.Item>
                            </div>
                            <div className={`${styles.labeldown} formblock`}>
                                <Form.Item
                                    label="Message"
                                    name="message"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Required data missing",
                                        },
                                    ]}
                                    validateTrigger={['onBlur', 'onChange']}
                                >
                                    <AntTextAreas
                                        value={reportData.message}
                                        placeHolder="Enter Message"
                                        maxLength={2000}
                                        showCount={true}
                                        onChange={(e: any) => {
                                            setReportData({
                                                ...reportData,
                                                message: e.target.value,
                                            });
                                        }}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </Drawer>
        </div>
    )
}

export default React.memo(CreateScheduledReports)